export const MAX_FIND_PROVIDER_ATTEMPTS = 3;
export const MAX_EXCEPTION_RESOLVE_ATTEMPTS = 2;

export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_PAGE = 1;
export const DEFAULT_PAGE_SIZE_OPTIONS = [10, 20, 40, 50, 100];

export const NON_MEMBER_PORTAL_NAMES = ['reservations', 'f1'];
export const MEMBER_PORTAL_NAMES = [
  'mvp',
  'dentaquest',
  'ahc',
  'ahcadmin',
  'transport',
];

export const EDIT_MEMBER_PROFILE_NOT_ALLOWED_PORTAL_NAMES = ['ahcadmin'];
export const STANDING_ORDER_NOT_ALLOWED_PORTAL_NAMES = ['ahcadmin', 'ahc'];
export const MEMBER_PORTAL_NO_BENEFIT_PLAN_NAMES = [
  'No Transportation Benefits',
  'No Transportation Benefit',
];
export const NEXT_TWO_DAYS_APPOINTMENT_NOT_ALLOWED_PORTAL_NAMES = [
  'ahc',
  'transport',
  'mvp',
  'dentaquest',
];

// Midnight cutoff hours for pickup date auto-defaulting (0-23)
// Appointments between 12:00 AM and this hour default pickup to previous day
export const MIDNIGHT_CUTOFF_HOURS = 3;
